import { render, staticRenderFns } from "./DepartmentsAccount.vue?vue&type=template&id=b7e771fa"
import script from "./DepartmentsAccount.vue?vue&type=script&lang=js"
export * from "./DepartmentsAccount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports